import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Host,
  Inject,
  Injector,
  Input,
  OnInit,
  Renderer2,
  forwardRef,
} from "@angular/core";
import { ColumnData, EditorValidator } from "../../model";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FPreviewEditorService } from "../../service";
import { UploadAndPreviewComponent } from "../upload-and-preview/upload-and-preview.component";

@Component({
  selector: "preview-cell",
  templateUrl: "./preview-cell.component.html",
  styleUrls: ["./preview-cell.component.css"],
})
export class PreviewCellComponent implements OnInit {
  // 列信息
  @Input() column: ColumnData;
  // 当前是否编辑
  private _isEditing = false;
  get isEditing() {
    return this._isEditing;
  }
  @Input() set isEditing(v) {
    if (this._isEditing === v) {
      return;
    }
    this._isEditing = v;
    if (v && this.canEdit) {
      this.afterChangeEditing();
    }
    if (!this.cd["destroyed"]) {
      this.cd.detectChanges();
    }
  }
  @Input() previewIndex = -1;
  @Input() colIndex = -1;
  @Input() previewSettings;
  realValue;
  private render: Renderer2;
  form: FormGroup = new FormGroup({});
  // 是否能编辑
  get canEdit() {
    return this.column.editorTemplate || this.column.editor&&this.column.editor['type'];
  };

  cellContext: {};
  editorService: FPreviewEditorService;
  uploadPreview:UploadAndPreviewComponent;
  constructor(
    public el: ElementRef,
    public cd: ChangeDetectorRef,
    private injector: Injector,
    private fb: FormBuilder
  ) {
    this.editorService= this.injector.get(FPreviewEditorService,null); 
    this.render = this.injector.get(Renderer2);    
    this.uploadPreview=this.injector.get(UploadAndPreviewComponent);
  }

  ngOnInit() {
    this.initPreviewService();
    this.getRealDataValue();
    this.initCellTemplateContext();
    this.afterChangeEditing();
  }
  private initPreviewService(){
    if(!this.editorService){
        this.editorService=this.uploadPreview.getEditorService();  
    }
  }
  /**
   * 初始化单元格模版的上下文
   */
  private initCellTemplateContext() {
    if (this.previewIndex != -1 && this.colIndex != -1) {
      this.cellContext = this.editorService.getPreviewCtx(this.previewIndex,this.colIndex);
      this.cellContext['formGroup'] = this.form;
    }
  }
  /**
   * 改变编辑状态
   */
  private afterChangeEditing(){
    if(this.canEdit&&this.isEditing&&this.cellContext){
      if (!this.form || !Object.keys(this.form.controls).length) {
        this.initFormControl();
      }

      if (this.column.editorTemplate && this.column.editorTemplate.elementRef) {
        this.cellContext['formGroup'] = this.form;
        // 因为附件是多行编辑
        // setTimeout(() => {
        //   if (this.el) {
        //     const input = this.el.nativeElement.querySelector('input,textarea');
        //     if (input) {
        //       input.focus();
        //     }
        //   }
        // }, 10);
      }
    }
  }
  getRealDataValue() {
    this.realValue = this.editorService.getRealDataValue(this.previewIndex, this.column['field']);
  }
  getRowData() {
    return this.editorService.getRowData(this.previewIndex);
  }

  initFormControl() {
    this.form = this.fb.group({});
    this.createControl();
    this.form['bindingData'] = this.cellContext['rowData'];
  }
  createControl() {
    if (!this.canEdit) { return; }
    if (!this.form.controls[this.column.field]) {
      const control = this.createFormControl();
      this.form.addControl(this.column.field, control);
    }
  }
  private createFormControl() {
    return this.fb.control( this.realValue, {
      validators: this.column.editor ? this.bindValidations(this.column.editor.validators) : null
    });
  }
  /**
   * 支持使用angular内部的校验
   * 说明：
   * 1、不予devkit绑定在一起可以使用这样的结构，editor:{options:required,validators:[{ type: 'required'}]}
   * 这样通过内部绑定的formControl来触发校验
   * 2、与devkit绑定在一起的时候，使用这样的结构，editor:{options:required},validators:[{ type: 'required'}]
   * 这样触发devkit本身的校验
   * @param validators 
   * @returns 
   */
  private bindValidations(validators: EditorValidator[]) {
    const validations = [];
    if (validators && validators.length) {

      validators.forEach((v: EditorValidator) => {
        let validation = null;
        switch (v.type) {
          case 'required':
            validation = Validators.required;
            break;
          case 'min':
            validation = Validators.min(v.value);
            break;
          case 'max':
            validation = Validators.max(v.value);
            break;
          case 'minLength':
            validation = Validators.minLength(v.value);
            break;
          case 'maxLength':
            validation = Validators.maxLength(v.value);
            break;
          case 'email':
            validation = Validators.email;
            break;
          case 'requiredTrue':
            validation = Validators.requiredTrue;
            break;
          case 'pattern':
            validation = Validators.pattern(v.value);
            break;
        }
        if (validation) {
          validations.push(validation);
        }
      });
    }
    return validations;
  }
}
